import React from 'react';
import CustomDialog from '@configuratorware/configurator-frontendgui/Shared/Components/CustomDialog';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import MainButton from '@configuratorware/configurator-frontendgui/Shared/Components/MainButton';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import DialogActions from '@material-ui/core/DialogActions';
import { makeStyles } from '@material-ui/core/styles';
import { twoSegmentsDialogShown } from '../Reducers/HintMessages/Actions';
import { useDispatch, useSelector } from 'react-redux';

const useStyles = makeStyles(() => ({
  activeButton: {
    textTransform: 'none',
  },
}));
export const TwoSegmentsDialog = () => {
  const dispatch = useDispatch();
  const { showTwoSegmentsDialog } = useSelector((state) => state.hintMessages);
  const onClose = () => {
    dispatch(twoSegmentsDialogShown());
  };
  const classes = useStyles();
  return (
    <CustomDialog open={showTwoSegmentsDialog} onCancel={() => onClose()}>
      <DialogTitle>
        <Typography variant="h6">{t('twoSegmentsDialog.title')}</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography>{t('twoSegmentsDialog.content')}</Typography>
      </DialogContent>
      <DialogActions>
        <MainButton onClick={onClose} className={classes.activeButton}>
          {t('twoSegmentsDialog.close')}
        </MainButton>
      </DialogActions>
    </CustomDialog>
  );
};
